import React from "react";

import PageHeading from "2g-page-heading";

import getNextWeekDates from "b2b/utils/date/getNextWeekDates";

import ZadostiOdsouhlaseneTable from "b2b/components/zadosti-odsouhlasene-table/ZadostiOdsouhlaseneTable";
import response from "b2b-devel/zadosti/sumar.json";

function ZadostiOdsouhlaseneTableExample() {
  const obdobi = { ...getNextWeekDates() };
  const zdroj = response[0].zdroje[0].zdroj;
  return (
    <>
      <div data-testid="zadostiOdsouhlaseneTable">
        <PageHeading>ZadostiOdsouhlaseneTable</PageHeading>
        <ZadostiOdsouhlaseneTable
          datumDo={obdobi.datumDo}
          datumOd={obdobi.datumOd}
        />
      </div>
      <div data-testid="zadostiOdsouhlaseneTableWithZdroj">
        <PageHeading>ZadostiOdsouhlaseneTable - zdroj</PageHeading>
        <ZadostiOdsouhlaseneTable
          datumDo={obdobi.datumDo}
          datumOd={obdobi.datumOd}
          zdroj={zdroj}
        />
      </div>
    </>
  );
}

export default React.memo(ZadostiOdsouhlaseneTableExample);
